import { useTranslation } from 'hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { Button } from 'components/Button'
import Link from 'next/link'
import { Stack } from '../../../../../components/Stack'
import Image from 'next/image'
import { Text } from 'components/Text'
import { freezeDriedProducts, frozenProducts } from './products'
import {
  SelectRecipeRoot,
  SelectRecipeWrapper,
  Header,
  ProductListContainer,
  ProductListItem,
  ImageWrapper,
  PointsList,
  PointsListItem,
  ProteinName,
  CheckIcon,
  ButtonBox,
} from './SelectRecipe.styles'

type SelectRecipeProps = {
  type: 'frozen' | 'freeze-dried'
}

export const SelectRecipe = (props: SelectRecipeProps) => {
  const { t } = useTranslation()
  const { type } = props

  return (
    <SelectRecipeRoot>
      <SelectRecipeWrapper>
        <Header>{t(`recipes-overview:select-recipes.${type}.title`)}</Header>
        <PointsList>
          <PointsListItem>
            <CheckIcon name="check" />
            <Text size="caption" weight="semiBold" align="center" transform="uppercase">
              {t(`recipes-overview:select-recipes.points.1`)}
            </Text>
          </PointsListItem>
          <PointsListItem>
            <CheckIcon name="check" />
            <Text size="caption" weight="semiBold" align="center" transform="uppercase">
              {t(`recipes-overview:select-recipes.points.2`)}
            </Text>
          </PointsListItem>
          <PointsListItem>
            <CheckIcon name="check" />
            <Text size="caption" weight="semiBold" align="center" transform="uppercase">
              {t(`recipes-overview:select-recipes.points.3`)}
            </Text>
          </PointsListItem>
        </PointsList>
        {type === 'frozen' ? (
          <ProductListContainer>
            {frozenProducts.map((product) => (
              <ProductListItem key={product.name}>
                <Stack direction="row" gap="2">
                  <ImageWrapper>
                    <Image src={product.image} alt={product.imageAlt} />
                  </ImageWrapper>
                  <Stack direction="column" gap="1">
                    <ProteinName>
                      <Trans i18nKey={product.name} />
                    </ProteinName>
                    <Text as="p" size="caption">
                      <Trans i18nKey={product.description} />
                    </Text>
                  </Stack>
                </Stack>
                <Link href={`/recipes/${product.link}`} passHref>
                  <Button
                    variant="secondaryAlt"
                    as="a"
                    size="small"
                    css={{
                      paddingLeft: '$1',
                      paddingRight: '$1',
                    }}
                  >
                    {t('recipes-overview:select-recipes.button')}
                  </Button>
                </Link>
              </ProductListItem>
            ))}
          </ProductListContainer>
        ) : (
          <ProductListContainer type="freeze-dried">
            {freezeDriedProducts.map((product) => (
              <ProductListItem type="freeze-dried" key={product.name}>
                <ImageWrapper type="freeze-dried">
                  <Image src={product.image} alt={product.imageAlt} />
                </ImageWrapper>
                <Stack direction="column" gap="1">
                  <ProteinName>
                    <Trans i18nKey={product.name} />
                  </ProteinName>
                  <Text as="p" size="caption">
                    <Trans i18nKey={product.description} />
                  </Text>
                  <Link href={product.link} passHref>
                    <Button
                      variant="secondaryAlt"
                      as="a"
                      size="small"
                      css={{
                        paddingLeft: '$1',
                        paddingRight: '$1',
                      }}
                    >
                      {t('recipes-overview:select-recipes.button')}
                    </Button>
                  </Link>
                </Stack>
              </ProductListItem>
            ))}
          </ProductListContainer>
        )}
        <ButtonBox>
          <Link passHref href="/meal-plan">
            <Button>{t('recipes-overview:select-recipes.cta-button')}</Button>
          </Link>
        </ButtonBox>
      </SelectRecipeWrapper>
    </SelectRecipeRoot>
  )
}

SelectRecipe.displayName = 'SelectRecipe'
